<template>
  <div style="padding-bottom: 50px;">
    <div class="empty-address" v-if="!isEmpty">
      <h3>您还没有收货地址</h3>
      <p>可以点击添加地址来新增收货地址</p>
    </div>
    <ul>
      <li v-for="(address, idx) in addressList">
        <i class="ico ico-del float-right pointer" @click="del(address, idx)"></i>
        <SingleAddress :address="address"></SingleAddress>
      </li>
    </ul>
    <div v-if="!addressList" class="text-center">
      <Loading></Loading>
    </div>
    <AddAddressDialog v-on:success="getAddressList" style="margin-left: 20px;color:#666;">
      <span class="pointer" @click="showForm = true"><i class="add"></i> <span class="add-tip">添加地址</span></span>
    </AddAddressDialog>
  </div>
</template>

<script>
import api from '../../services/api.js'
import AddAddressDialog from '../publish_task/address/AddAddressDialog'
import SingleAddress from '../publish_task/address/SingleAddress'
import Loading from '../../components/Loading'

export default {
  name: 'AddAddress',
  components: {
    AddAddressDialog: AddAddressDialog,
    SingleAddress: SingleAddress,
    Loading: Loading
  },
  computed: {
  },
  data () {
    return {
      addressList: null,
      isEmpty: true
    }
  },
  created () {
    this.getAddressList()
  },
  methods: {
    async getAddressList () {
      let res = await api.getAddressList(this)
      this.addressList = res.body.result || []
      this.isEmpty = !!this.addressList.length
    },
    async del (address, idx) {
      await api.post(this, {
        path: 'buyer.php',
        api: 'delete_address',
        data: {
          id: address.id
        },
        loading: 'passwordLoading'
      })
      this.addressList.splice(idx, 1)
      if(this.addressList.length == 0){
        this.isEmpty = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .empty-address {
    padding: 0 0 35px 20px;
    border-bottom: 1px solid #D7D7D7;
    margin-bottom: 35px;

    h3 {
      margin-bottom: 15px;
    }

    p {
      color: #666666;
    }
  }

  li {
    border-bottom: 1px solid #D7D7D7;
    margin-bottom: 35px;
    padding: 0 35px 35px 20px;
  }
  .add {
    font-size: 15px !important;
    letter-spacing: 0.1px !important;
    font-family: 'Function Pro Demi' !important;
    color: #333 !important;
    line-height: 33px !important;
  }
  .add::before {
    box-sizing: border-box;
    content: "+" !important;
    display: inline-block !important;
    border: 1px solid #999 !important;
    color: #888 !important;
    border-radius: 50% !important;
    // margin-right: 5px !important;
    height: 16px !important;
    width: 16px !important;
    vertical-align: baseline !important;
    line-height: 11px !important;
    text-align: center !important;
    margin-top: -4px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user_center/AddressList.vue